import { apiSlice } from "@/app/api/apiSlice";
import { urlConfig } from "@/config";

export interface ReferralUser {
  _id: string;
  email: string;
  name: string;
  phoneNumber?: string;
}

export interface Referral {
  _id: string;
  user: string | ReferralUser;
  referralId: string;
  refBy: {
    _id: string;
    email: string;
    name: string;
    phoneNumber: string;
  } | null;
  earned: number;
  withdrawn: number;
  balance: number;
  createdAt: string;
  updatedAt: string;
  firstTransactionCredited?: boolean;
  /** Programme rule from GET /referrals (absent on pre-5.4.0 wallets). */
  rewardAmount?: number;
  minTradeValue?: number;
}

export interface ReferredUser extends Referral {
  user: ReferralUser;
}

export interface ReferralReward {
  _id: string;
  user: string;
  referralUser: {
    _id: string;
    email: string;
    name: string;
  };
  amount: number;
  txId: string;
  txType: string;
  createdAt: string;
  updatedAt: string;
}

export const referralSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getReferral: build.query<Referral, void>({
      query: () => `${urlConfig.referralsUrl}/referrals/`,
      providesTags: ["Referrals"],
    }),
    getReferredUsers: build.query<ReferredUser[], void>({
      query: () => `${urlConfig.referralsUrl}/referrals/referred/`,
      providesTags: ["ReferredUsers"],
    }),
    getReferralRewards: build.query<ReferralReward[], void>({
      query: () => `${urlConfig.referralsUrl}/referrals/rewards/`,
      providesTags: ["ReferralRewards"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetReferralQuery,
  useGetReferredUsersQuery,
  useGetReferralRewardsQuery,
} = referralSlice;
